export function ChangeLossControlCards (cards, name){
    return{
        type: "ChangeLossControlCards",
        info: "ChangeLossControlCards",
        payload: {
            cards: cards,
            name: name
        }
    }
}

export function changeLossControlDonutData(donutGraph){
    return{
        type: 'changeDonutData',
        info: "changeDonutData",
        payload: { donutGraph: donutGraph }
    }
}

export function changeLossControlDonutDataTotal(donutGraphTotal){
    return{
        type: 'changeDonutDataTotal',
        info: "changeDonutDataTotal",
        payload: { donutGraphTotal: donutGraphTotal }
    }
}

export function ChangeLossControlTotalCards (hasMoreCards){
    return{
        type: "ChangeLossControlTotalCards",
        info: "ChangeLossControlTotalCards",
        payload: { hasMoreCards: hasMoreCards }
    }
}

export function ChangeLossControlDays(days){
    return{
        type: "ChangeLossControlDays",
        info: "ChangeLossControlDays",
        payload: { days: days }
    }
}

export function ChangeLossControlDay (day){
    return{
        type: "ChangeLossControlDay",
        info: "ChangeLossControlDay",
        payload: { day: day }
    }
}

export function ChangeLossControlMonth (month){
    return{
        type: "ChangeLossControlMonth",
        info: "ChangeLossControlMonth",
        payload: { month: month }
    }
}

export function ChangeLossControlCardsLoading (isLoading){
    return{
        type: "ChangeLossControlCardsLoading",
        info: "ChangeLossControlCardsLoading",
        payload: { isLoading: isLoading }
    }
}

export function ChangeLossControlAutoplay (isAutoplayEnabled){
    return{
        type: "ChangeLossControlAutoplay",
        info: "ChangeLossControlAutoplay",
        payload: { isAutoplayEnabled: isAutoplayEnabled }
    }
}

export function ChangeLossControlDaysLoading (isLoading){
    return{
        type: "ChangeLossControlDaysLoading",
        info: "ChangeLossControlDaysLoading",
        payload: { isLoading: isLoading }
    }
}

export function ChangeLossControlyear (year){
    return{
        type: "ChangeLossControlyear",
        info: "ChangeLossControlyear",
        payload: { year: year }
    }
}

export function ChangeLossControlStatus (status){
    return{
        type: "ChangeLossControlStatus",
        info: "ChangeLossControlStatus",
        payload: { status: status }
    }
}

export function ChangeLossControlMode (mode){
    return{
        type: "ChangeMode",
        info: "ChangeMode",
        payload: { mode: mode }
    }
}


